import {
  registerWidget,
  DME,
  DMEData,
  dmeConfig,
  generalSettings,
} from "dmeditor";

interface Entity {
  image?: string;
  text?: string;
  link?: string;
  title?: string;
  subTitle?: string;
}

export const CollegeRender = (props: DME.WidgetRenderProps<Entity>) => {
  const {
    blockNode: { data },
  } = props;

  const { image, text, link, title, subTitle } = data;

  return (
    <div className="rounded-lg w-full md:w-[30rem] relative">
      <div className="bg-white rounded md:rounded-lg overflow-hidden rounded-lg">
        <div className="rounded-lg w-full h-full font-semibold">
          <div className="flex flex-col w-3/4 py-4 px-5 text-gray-700">
            <span className="text-zdsecondary-600 text-xs pr-1 flex items-baseline gap-x-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                width="1em"
                height="1em"
                fill="currentColor"
                className="svgr"
              >
                <path d="M464 96H338.8l35.7-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 94.2 182.8 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L173.2 96H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h16v32h48l21.3-32h245.3l21.3 32h48v-32h16c26.5 0 48-21.5 48-48V144c.1-26.5-21.4-48-47.9-48zm-72 312s0 8-168 8c-152 0-152-8-152-8s-8 0-8-120 8-120 8-120 0-8 152-8c168 0 168 8 168 8s8 0 8 120-8 120-8 120zm72-100c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v8z"></path>
              </svg>{" "}
              {title}
            </span>
            <h3 className="m-0 text-lg">{subTitle}</h3>
          </div>
          <div className="flex items-center">
            <div className="relative w-full aspect-16/9  rounded-lg">
              <img src={dmeConfig.general.imagePath(image || "")} alt="" />
            </div>
          </div>
          <a
            href={link}
            className="cursor-pointer no-underline text-zdsecondary-800 dark:text-zdsecondary-300 hover:text-zdsecondary-600 dark:hover:text-zdsecondary-50 bg-black w-full opacity-75 block"
            rel=""
          >
            <div className="py-3 px-5 flex gap-x-2 items-center text-white">
              <span>{text || ""}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                width="1em"
                height="1em"
                fill="currentColor"
                className="svgr"
              >
                <path d="M48 32h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm60 268h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H108c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"></path>
              </svg>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default () => {
  registerWidget(
    {
      type: "mf-college",
      icon: "matchfit",
      name: "College",
      category: "basic",
      settings: [
        { name: "Title", settingComponent: "input", property: ".title" },
        { name: "Sub title", settingComponent: "input", property: ".subTitle" },
        { name: "Image", settingComponent: "image", property: ".image" },
        { name: "Text", settingComponent: "input", property: ".text" },
        { name: "Link", settingComponent: "input", property: ".link" },
        ...generalSettings,
      ],
      events: {
        updateData: () => {},
        createBlock: (): DMEData.CreatedBlock => {
          return {
            type: "mf-college",
            data: {},
          };
        },
      },
    },
    {
      render: CollegeRender,
    }
  );
};
